export const sharedCommon = {
  reload: "Reload",
  close: "Close",
  downloadOnAppStore: "Download on the App Store",
  downloadOnGooglePlay: "Download on Google Play",
  Labs: "Labs",
  learnMore: "Learn more",
  readMore: "Read more",
  readLess: "Read less",
  collapse: "Collapse",
  expandRow: "Expand row",
  collapseRow: "Collapse row",
  completed: "Completed",
  GotIt: "Got it",
  DontShowMeThisAgain: "Don't show me this again",

  // Append to aria-label / visually-hidden span on target="_blank" CTAs.
  opensInNewTab: "(opens in a new tab)",

  pageTitle: "{{- pageTitle }} | Fullscript",
  emersonPageTitle: "{{- pageTitle }} | Emerson Ecologics",
  defaultPageTitle: "Fullscript",
  defaultPageTitleEmerson: "Emerson Ecologics",

  similarProductsTo: "Similar products to {{- productName}}",

  tags: {
    is_fullscript_tested: "Enhanced testing",
    restricted: "Restricted access",
    is_new_variant: "New",
  },

  // Confirm Loading Modal
  PlacingOrder: "Placing order...",
  PleaseWaitPlacing: "Please wait while we place your order.",
  DoNotExit: "Do not exit this screen or your order may be lost.",

  // Impersonation Terms
  Impersonating: "Impersonating \xA0",
  StopImpersonatingTitle: "Stop impersonating",
  stopImpersonating: "Stop impersonating and go back to admin",
  operatingAs:
    "You are operating as <1>{{- userFullName}}'s</1> profile. <3>$t(stopImpersonating)</3>",
  InvalidDOB: "Invalid date of birth",
  DOBMustBeAtLeast18YearsOld: "You must be at least 18 years old",
  AddToCart: "Add to cart",
  AddToCartWithPrice: "Add to cart | {{price}}",
  AddAllToCart: "Add all to cart",
  AllInclusiveNoHiddenFees: "All-inclusive · No hidden fees",
  SelectADifferentSize: "Select a different size",
  AddedToCart: "Added to cart",
  AddedToCartWithCount: "{{count}} added to cart",
  AddedToCartWithCount_plural: "{{count}} added to cart",
  MiniCartExtraItems: "+ {{count}} more",
  ViewCart: "View cart",
  QuantityAdded: "{{quantity}} added!",
  OutOfStock: "Out of stock",
  PerUnit: "/ Unit",

  ProductOutOfStockOrDiscontinued:
    "This product cannot be purchased or prescribed because it is out of stock or discontinued",
  Sku: "SKU",
  selectOptions: "Select options",
  dosage: "Dosage",

  practitionerTerm: "practitioner",
  practitionerTermPlural: "practitioners",

  dispensary: {
    settings: "Settings",
    quickLinks: "Quick links",
    dispensaryLandingPage: "Your store sign up link",
    dispensaryLandingsDescription: "Let patients sign up for your store from this sharable link.",
    currentTaking: "Ask patients what they're currently taking",
    currentTakingDescription:
      "Capture clinical context about the supplements and medications {{patientTerm}} are taking.",
  },

  // TreatmentPlan Terms
  prescription: "prescription",
  prescription_plural: "prescriptions",
  prescription_capitalized: "Prescription",
  prescription_capitalized_plural: "Prescriptions",
  prescription_present_participle: "prescribing",
  prescription_present_participle_capitalized: "Prescribing",
  prescription_past_participle: "prescribed",
  prescription_past_participle_capitalized: "Prescribed",
  prescription_verb: "prescribe",
  prescription_verb_capitalized: "Prescribe",
  recommendation: "recommendation",
  recommendation_plural: "recommendations",
  recommendation_capitalized: "Recommendation",
  recommendation_capitalized_plural: "Recommendations",
  recommendation_present_participle: "recommending",
  recommendation_present_participle_capitalized: "Recommending",
  recommendation_past_participle: "recommended",
  recommendation_past_participle_capitalized: "Recommended",
  recommendation_verb: "recommend",
  recommendation_verb_capitalized: "Recommend",
  restrictedForWholesale: "Restricted for wholesale",
  productDisclaimer:
    "Images are provided by the manufacturers. Fullscript does not verify all content.",

  // Patient Terms
  client: "client",
  client_plural: "clients",
  client_possessive: "client's",
  client_capitalized: "Client",
  client_capitalized_plural: "Clients",
  client_capitalized_possessive: "Client's",
  patient: "patient",
  patient_plural: "patients",
  patient_possessive: "patient's",
  patient_capitalized: "Patient",
  patient_capitalized_plural: "Patients",
  patient_capitalized_possessive: "Patient's",

  // Community Plan Terms
  // - Default: "community plan"
  // - hasProtocolsAccess enabled: "protocol"
  // - vanguard_alternative_community_plans_term enabled: "care support supplements"
  community_plan: "community plan",
  community_plan_plural: "community plans",
  community_plan_capitalized: "Community plan",
  community_plan_capitalized_plural: "Community plans",
  protocol: "protocol",
  protocol_plural: "protocols",
  protocol_capitalized: "Protocol",
  protocol_capitalized_plural: "Protocols",
  health_plan: "care support supplements",
  health_plan_plural: "care support supplements",
  health_plan_capitalized: "Care support supplements",
  health_plan_capitalized_plural: "Care support supplements",

  USA: "USA",
  CAN: "CA",
  UnitedStates: "United States",
  Canada: "Canada",
  Back: "Back",
  Next: "Next",
  Skip: "Skip",
  SkipForNow: "Skip for now",
  Done: "Done",
  Submit: "Submit",
  BackToCatalogHome: "Back to catalog home",

  EmptySimilarProducts: "It looks like there are no <1>similar</1><2/><3>products</3> available",
  SimilarProducts: "Similar products",
  Description: "Description",
  ReadFullDescription: "Read full description",
  ReadFullDescriptionOf: "Read full description of {{productName}}",
  ReadLessDescriptionOf: "Read less of {{productName}} description",

  // PDP Collapsible Sections
  warnings: "Warnings",
  healthConditions: "Health conditions",
  dietaryRestrictions: "Dietary restrictions",
  moreDietaryRestrictions: "+{{count}} more",
  heatSensitivePillLabel: "Heat sensitive",
  heatSensitivePillTooltip:
    "Heat-sensitive items (e.g. probiotics, fish oils) may ship with a cold pack. Consider priority shipping in warm months.",
  ServingSize: "Serving size: {{size}} {{unit}}",
  SupplementFacts: "Supplement Facts",
  IngredientRow: "{{amount}} {{unit}} {{name}}",
  AmountPerServing: "Amount per serving",
  OtherIngredients: "Other ingredients:",
  CollapseIngredientDetails: "Collapse {{name}} details",
  ExpandIngredientDetails: "Expand {{name}} details",
  SubIngredientOf: "{{name}}, {{amount}}, sub-ingredient of {{parentName}}",
  SuggestedUse: "Suggested use",

  SizeOfVariant: "<0>Size:</0> {{variantDescriptor}}",
  ProtocolPlanSizeLabel: "Size:",

  // Duration
  DurationOptional: "Not selected",
  Duration: "Duration",
  UntilSymptomsResolve: "Until symptoms resolve",
  Ongoing: "Ongoing",
  For1Week: "For 1 week",
  For2Weeks: "For 2 weeks",
  For3Weeks: "For 3 weeks",
  For1Month: "For 1 month",
  For2Months: "For 2 months",
  For3Months: "For 3 months",
  For6Months: "For 6 months",

  // Frequency
  OncePerDay: "Once / day",
  TwicePerDay: "Twice / day",
  ThreeTimesPerDay: "Three times / day",
  FourTimesPerDay: "Four times / day",
  EveryMorning: "Every morning",
  EveryNight: "Every night",
  OnceADay: "once per day",
  PerDay: "per day",
  AsNeeded: "As needed",

  // Dates
  January: "January",
  February: "February",
  March: "March",
  April: "April",
  May: "May",
  June: "June",
  July: "July",
  August: "August",
  September: "September",
  October: "October",
  November: "November",
  December: "December",

  All: "All",
  brands: "brands",
  Brands: "Brands",
  Brand: "Brand",
  Popular: "Popular",
  Filters: "Filters",
  CloseFilters: "Close filters",
  RemoveIngredient: "Remove ingredient",
  SearchIngredients: "Search ingredients...",
  NoResults: "No results to show...",
  Ingredient: "Ingredient",
  Ingredients: "Ingredients",
  SubTypesOf: "Subtypes of {{- ingredient}}",
  ShowAll: "Show all",
  ShowAllWithCount: "+{{count}} Show all",
  SearchCatalog: "Search Catalog",
  Search: "Search",
  SearchProducts: "Search for products...",
  SearchAll: "Search for products, brands, ingredients, and more...",
  servings: "Serving(s)",
  Condition: "Condition",
  SupplementType: "Supplement type",
  SearchFor: "Search for products named ",
  LoadMoreFilters: "Load more {{title}}",
  ShowMore: "Show more",
  ShowLess: "Show less",
  ShowMoreEllipsis: "... Show more",
  ShowLessEllipsis: "... Show less",
  Remove: "Remove",
  Undo: "Undo",
  RemoveAll: "Remove all",
  RemoveItem: "Remove {{- item}}",
  Compare: "Compare",
  CompareProducts: "Compare products",
  Edit: "Edit",
  Stop: "Stop",
  Save: "Save",
  Result: "{{count}} result",
  Result_plural: "{{count}} results",
  CatalogSearchTitleShowing: "Showing",
  CatalogSearchTitleOutOf: "out of",
  CatalogSearchTitleResult: "result",
  CatalogSearchTitleResultFor: "result for",
  CatalogSearchTitleResults: "results",
  CatalogSearchTitleResultsFor: "results for",
  CatalogSearchTitleZero: "No results found",
  CatalogSearchTitleZeroWithQuery: "No results found for",
  LoadMore: "Load more",
  Sort: "Sort",
  Common: "Common",
  Confirm: "Confirm",
  Cancel: "Cancel",
  Restore: "Restore",
  Manage: "Manage",
  Select: "Select",
  PreviouslyOrdered: "Previously ordered",
  PrimaryProduct: "Primary product",
  Featured: "Featured",
  NumOfProductsSelected: "{{count}}/4 products selected",
  OnSale: "On sale",
  TotalDiscount: "Total discount",
  Backordered: "Backordered",
  Discontinued: "Discontinued",
  AddProductToPlan: "Add {{productName}} to plan",
  RemoveProductFromPlan: "Remove {{productName}} from plan",
  ProductDiscontinued: "{{productName}} discontinued",
  ProductRestricted: "{{productName}} restricted",
  ProductOutOfStock: "{{productName}} out of stock",
  AddProductWithSubstitution: "Add {{productName}} with substitution",
  EditSubstitutesForProduct: "Edit substitutes for {{productName}}",
  SeeSimilarProductsTo: "See similar products to {{productName}}",
  Form: "Form",
  Allergens: "Allergens",
  Demographic: "Demographic",
  Certifications: "Certifications",
  More: "More",
  ShowAllAttachments: "ShowAllAttachments",
  LessThan: "Less than or equal",
  GreaterThan: "Greater than or equal",
  EqualTo: "Equal to",
  AnyValue: "Any value",
  Clear: "Clear",
  Clearall: "Clear all",
  ClearFilters: "Clear filters",
  ClearSearch: "Clear search",
  ClearAllSearchFilters: "Clear all search filters",
  DidYouMeanThisEmail: "Did you mean <1>{{suggestedEmail}}</1>?",
  discountPill: "{{discount}}% off orders",
  PercentOff: "{{percent}}% off",
  PercentOffMsrp: "{{percent}}% off MSRP",
  SelectSuggestedEmail: "Select suggested email",
  EmailRequired: "Email is required",
  EmailMustHaveAt: `Email must include "@"`,
  EmailMustHaveDot: `Email must include "."`,
  EmailInvalidFormat: `Email is invalid format`,
  Email: "Email",
  EmailAddress: "Email address",
  totalDiscount: "{{discount}}% total discount applied to all products",
  ouraDiscount: "{{discount}}% off applied on ŌURA",
  cartDiscountBanner: "Your practitioner has applied a {{discount}}% discount to all products",
  promotionTotalDiscountBanner:
    "Total discount is now {{discount}}% on all products for a limited time",
  MyAccount: "My account",
  footerTerms:
    "This page is protected by reCAPTCHA, and subject to the <1>Google Privacy Policy</1> and <3>Google Terms of Service</3>",
  deliveryCountryUS: "US delivery only",

  lastFourDigits: "last four digits",
  CreditCardEndingIn: "Credit card ending in {{lastFourDigits}}",
  cardNumber: "Card number",
  expiry: "expiry",
  expiryDate: "Expiry date",
  expiryLabel: "EXP",
  Exp: "Exp. {{month}}/{{year}}",
  CVC: "CVC",
  mmYY: "MM/YY",
  missingBilling: "Missing billing",
  update: "Update",
  holdOn: "Hold on!",
  exitWithoutSaving:
    "You are about to exit this page without saving. If you proceed all information you have provided up to this point will be lost. Are you sure you want to proceed?",
  finishAndSave: "Finish then save",
  leaveWithoutSaving: "Leave without saving",
  Loading: "Loading",
  Dismiss: "Dismiss",
  createdIn: "Created in {{sourcePlatform}}",
  orderedIn: "Ordered in {{sourcePlatform}}",
  PractitionerAvatar: "Avatar for Practitioner",
  userAvatar: "User avatar",
  AvatarFor: "Avatar for {{- firstName}} {{- lastName}}",
  takeTheTour: "Take the tour",
  beta: "BETA",
  Interpunct: "•",
  youSave: "You save",
  Savings: "Savings",
  Notifications: "Notifications",
  notificationSettingsLoadError:
    "We couldn't load your notification settings. Please check your unsubscribe link and try again.",
  Step: "Step",
  PopularProducts: "Popular Products",
  viewProductDetails: "View product details",
  viewProductDetailsFor: "View product details for {{- name}}",
  copy: "Copy",
  copyLink: "Copy link",
  copyLinkFor: "Copy link for {{- name}}",
  linkCopied: "Link copied",
  blockUpdating: "To update contact customer support",
  productRemovedMessage: "This product has been removed and is no longer available for editing.",
  new: "New",

  // Delivery
  Estimated: "Estimated {{arrivalDate}}",
  EstimatedArrival: "Estimated arrival {{arrivalDate}}",
  DeliveryOptionAccessibleLabel: "Delivery Method: {{method}} - Cost: {{cost}}",
  BestOptionForHeatSensitive:
    "Best shipping option for <heatSensitive>heat-sensitive products</heatSensitive>",
  freeFirstUppercase: "Free",
  freeAllUppercase: "FREE",

  // Labs
  Sent: "Pending payment",
  Paid: "Paid",
  RequisitionReadySimple: "Requisition ready",
  ResultsIn: "Results in",
  Shipped: "Shipped",
  ChangesSaved: "Changes saved",

  // Checkout
  EnteredAddress: "Entered address",
  VerifiedAddress: "Verified address",
  ApplyDiscountCode: "Apply discount code",
  DiscountCode: "Discount code",
  PromotionCode: "Promotion code",
  RemovePromoCode: "Remove promotion code",
  InvalidPromoCode: "Promo code invalid or not applicable",
  InvalidDiscountCode: "Invalid discount code",
  Apply: "Apply",

  restrictedAccess: "Restricted access",
  FailedToCopyText: "Failed to copy to clipboard",
  CopiedToClipboard: "Copied to clipboard",

  // Shipping address drawer
  shippingAddress: "Shipping address",
  addNewShippingAddress: "Add new shipping address",
  updateShippingAddress: "Update shipping address",
  defaultAddress: "Default address",
  defaultAddressDescription:
    "This address will be selected automatically next time you make a purchase.",
  asAutoRefillDefaultAddress: "Use as auto refill shipping address",
  asAutoRefillDefaultAddressDescription:
    "Your auto refills are shipping to an address different than the one you've listed above. Would you like to also update your auto refill address?",
  closeDrawer: "Close drawer",
  country: "Country",
  streetAddress: "Street address",
  suiteEtc: "Suite, etc. (optional)",
  selectState: "Select state",
  selectProvince: "Select province",
  state: "State",
  province: "Province",
  city: "City",
  zipCode: "Zip code",
  invalidZipCode: "Invalid zip code",
  postalCode: "Postal code",

  // Shipping address
  default: "Default",
  viewMoreOptions: "View more options",
  delete: "Delete",
  saveAsDefault: "Save as default",
  selectableAddressAriaLabel: "Select address: {{address}}",
  deleteAddress: "Delete address",
  deleteAddressConfirmation: "Are you sure you want to delete the address {{address}}?",
  deleteAddressSuccess: "The address has been successfully deleted from your account.",
  deleteAddressError:
    "An error has occurred while attempting to delete the address. Please try again or contact support.",
  shippingAddressSaved: "Your shipping address has been saved.",
  defaultAddressUpdated: "Your default address has been updated.",
  shippingFromFullscript: "Shipping from Fullscript",
  shippingFromOura: "Shipping from ŌURA",

  // Payment method
  selectablePaymentMethodAriaLabel: "Select {{ cardType }} card ending in {{ lastDigits }}",
  deletePaymentMethod: "Delete payment method",
  deletePaymentMethodConfirmation: "Are you sure you want to delete this card from your account?",
  deletePaymentMethodSuccess: "Your card has been successfully deleted from your account.",
  deletePaymentMethodError:
    "An error has occurred while attempting to delete your card. Please try again or contact support.",
  defaultPaymentMethodSuccess: "Your default payment method has been updated.",
  paymentMethodSaved: "Your payment method has been saved.",
  checkoutNewCard: "Credit or debit card",
  applePay: "Apple Pay",
  googlePay: "Google Pay",
  klarna: "Klarna",
  klarnaHasAutoRefillDescription: "*Buy now pay later not available with auto refills",
  klarnaMixedCartNotification:
    "Klarna is not available when ordering labs and products at the same time. You can still use Klarna if you buy them separately.",
  klarnaLabsNotification: "Klarna is currently not available when ordering labs.",
  klarnaNotAvailableWithAutoRefill: "Klarna is not available with auto refills",

  // Payment method drawer
  paymentMethod: "Payment method",
  billingAddress: "Billing address",
  sameAsShippingAddress: "Same as shipping address",
  defaultPaymentMethod: "Default payment method",
  defaultPaymentMethodDescription:
    "This card will be selected automatically next time you make a purchase.",
  forAutoRefills: "Use for auto refills",
  forAutoRefillsUpdateDescription:
    "This will update your payment method for all auto refill orders.",
  forAutoRefillsAddressUpdateDescription:
    "This will update your shipping address for all auto refill orders.",
  forAutoRefillsWillUseThisCard: "Any scheduled auto refills will use this card.",
  forAutoRefillsWillUseThisShippingAddress:
    "Any scheduled auto refills will use this shipping address.",
  forAutoRefillsCardMustBeSaved:
    "This card must be saved to complete the auto refill in your cart.",
  forAutoRefillsAddressMustBeSaved:
    "This shipping address must be saved to complete the auto refill in your cart.",
  addNewPaymentMethod: "Add new payment method",
  addPaymentMethod: "Add payment method",
  updatePaymentMethod: "Update payment method",
  firstName: "First name",
  lastName: "Last name",

  // Address and Payment Method Management
  AddNewPaymentMethod: "+ Add new payment method",
  AddNewShippingAddress: "+ Add new shipping address",
  ShipTo: "Ship to",
  PaymentMethod: "Payment method",
  NoShippingAddresses: "You have no shipping addresses added to your account.",
  NoPaymentMethods: "You have no payment methods added to your account.",

  poweredByGoogle: "powered by <1>Google</1>",
  poweredBy: "powered by",
  poweredByFullscript: "powered by Fullscript",
  Suggestions: "Suggestions",

  platforms: {
    EmersonEcologics: "Emerson Ecologics",
    Fullscript: "Fullscript",
  },
  toggleAccountProfile: "Toggle profile account settings",

  editBillingAddress: "Edit billing address",

  DesignationSearch: "Search for your health profession",
  DesignationNoResults: "No results found",

  serviceFee: "Service fee",

  // Preferred Product component
  WhyPreferredText: "Why is this a top pick for {{productCategory}}?",
  PreferredReasonInfo:
    "The Top Pick is selected to provide a quick way to identify high-quality, clinically effective products to meet common prescribing needs.\n\n" +
    "This product was selected based on the factors below:\n\n",
  PatientPreferredReasonInfoLine1:
    "This product has been chosen as a Top Pick by Fullscript based on factors like quality, ingredients, value, and availability. Your provider’s recommendation always comes first.\n\n",
  PatientPreferredReasonInfoLine2: "This product was selected based on the factors below:\n\n",
  PatientPreferredTooltip:
    "Top Pick is based on factors like quality, ingredients, and value. Your provider’s recommendation always comes first.",
  LearnMoreAboutOurProcess: "Learn more about our process",
  ReadMore: "Read more",
  ReadLess: "Read less",
  ReadMoreWhyTopPick: "Read more about why {{productName}} is a top pick?",
  ReadLessWhyTopPick: "Read less about why {{productName}} is a top pick?",
  ViewTopPickDetails: "View Top pick details",
  ViewEnhancedTestingDetails: "View Enhanced testing details",

  // Favorites
  FavoriteTooltip: "This product is in the practitioner’s favorites",

  // FS enhance tested
  fsTested: {
    Tested: "Enhanced testing",
    Tooltip: "Product potency and purity validated by additional, independent third-party testing.",
    Title: "How was this product tested?",
    AboutEnhancedTesting: "About enhanced testing",
    Description:
      "At Fullscript, every brand meets our stringent quality standards – but we don't stop there. With a focus on popular or problematic ingredient categories, we choose a select number of products and subject them to enhanced testing for purity and potency. By handpicking one or two lots of each product directly from our distribution facilities and shipping them to an independent third-party lab for additional testing, Fullscript validates potency and/or purity claims. No brands pay for inclusion in these programs, ensuring decisions remain clinically focused and unbiased.",
    Link: "Learn more about the testing methods",

    patient: {
      Tooltip:
        "This item has passed additional third-party testing to confirm what’s on the label is in the product.",
      Description:
        "Every product on Fullscript meets our high quality standards – but we don’t stop there. Enhanced Testing means select products are pulled directly from Fullscript’s shelves and tested by independent labs, so what’s on the label matches what’s in the product.",
    },
    emerson: {
      Description:
        "At Emerson Ecologics, every brand meets our elevated quality standards. But we don’t stop there. As an added layer of assurance, select products from popular or problematic categories are subjected to enhanced testing by independent third-party labs to confirm potency and purity claims, giving you more trust in the products you recommend. Brands cannot pay for inclusion in Enhanced Testing or to receive an “Enhanced Testing” badge, ensuring that decisions remain clinically-focused and unbiased.",
    },
  },

  // Canadian brand highlight
  canadianBrand: {
    Title: "Canadian brand",
    Description: "This product is from a brand founded and operated in Canada.",
  },

  PrescriptionOnlyPlan: "Only by recommendation",
  PrescriptionOnlyTooltip:
    "Available for purchase when {{treatmentPlanTerm}} by your practitioner. Contact your practitioner if you have additional questions.",
  PrescriptionOnlyTooltipPlan: "Available for purchase when recommended by your practitioner.",
  AddItemToCartAria: "Add {{item}} to cart",

  sourcePlatformTabsAriaLabel: "Source platform",

  // Cart Page
  CartPage: {
    purchaseSummary: "Order summary",
    discount: "Discounts ({{discountPercent}}%)",
    discountDollars: "-${{totalDiscount}}",
    subtotalDollars: "${{subtotal}}",
    taxesAndShippingAtCheckout: "Taxes and shipping at checkout.",
    discountsNotAppliedToLabs: "Dispensary discounts not applied to labs.",
    shippingAndReturns: "Shipping & returns",
    needHelp: "Need help?",
    helpModal: {
      title: "Need help?",
      chatOption: {
        title: "Start a chat",
        description: "Talk with an agent",
      },
      callOption: {
        title: "Call us",
        description: "+1-866-807-3828",
      },
      emailOption: {
        title: "Email us",
        description: "support@fullscript.com",
      },
    },
    shippingReturnsModal: {
      title: "Shipping & Returns",
      shipping: {
        title: "Shipping",
        locationQualifierUS: " within the continental United States",
        locationQualifierCA: " within Canada",
        description:
          "We offer free shipping on orders over ${{freeShippingThreshold}}{{locationQualifier}}.",
        additionalInfo: "Standard shipping typically takes 3-5 business days.",
        additionalInfoCA: "Standard shipping typically takes 2-4 business days.",
        moreDetails: "For more details, see our <Link>shipping policy</Link>.",
        shippingPolicyUrl: "https://support.fullscript.com/articles/patient-shipping-policy",
        shippingPolicyUrlCA:
          "https://support.fullscript.com/articles/patient-shipping-policy/#canada-shipping",
      },
      returns: {
        title: "Returns",
        description: "We offer a 30-day return policy for unopened products.",
        refundInfo: "Refunds will be processed within 5-7 business days.",
        policyNote: "Some restrictions may apply.",
        moreDetails: "For more details, see our <Link>return policy</Link>.",
        returnPolicyUrl: "https://support.fullscript.com/articles/return-policy",
      },
    },
  },
  NewArrivals: {
    title: "New arrivals",
    description: "See what's new",
  },
  metagenicsPromo: {
    patient: {
      title: "Save 20% on all Metagenics products",
      codeInstruction: "Use code <bold>START2026</bold> at checkout*",
      disclaimer: "*Offer ends January 31",
    },
    practitioner: {
      title: "Patients can save 20% on all Metagenics products",
      codeInstruction: "They can use the code <bold>START2026</bold> at checkout*",
      disclaimer: "*Offer ends January 31",
    },
  },

  remixMigrationReminder: {
    header:
      "This page is being migrated to Remix. Please also test your changes on the {{ app }} version 🙏",
    toggleLabel: "Remix ({{ enabled }})",
    hideReminder: "Hide reminder",
    showReminder: "Show reminder",
    Documentation: "Documentation",
  },
} as const;
